var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item dropdown",on:{"mouseenter":_vm.enteredhover,"mouseleave":_vm.exitedhover}},[_c('a',{staticClass:"nav-link justify-content-center",on:{"click":_vm.toggleStatus}},[_vm._t("activator")],2),_c('ul',{class:_vm.dropdownClass,style:({ 'display': _vm.hover ? 'block' : 'none' })},[_vm._t("items")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }